function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../locales/keys';
var ContactMethodsSectionController = /*#__PURE__*/function () {
  function ContactMethodsSectionController() {
    _classCallCheck(this, ContactMethodsSectionController);
    this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    this.contactPreferencesModel = {};
    this.contactEventTypeToContactMethods = [];
  }
  return _createClass(ContactMethodsSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      this.contactPreferencesModel = this.contactPreferencesDictionary.asMutable({
        deep: true
      });
      this.initializeContactEventTypeToContactModel();
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.updateCustomerModel(this.customerModel, this.contactPreferencesModel);
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "getContactPreferences",
    value: function getContactPreferences(contactPreferences) {
      var updatedContactPreferences = [];
      var cpKeys = Object.keys(contactPreferences);
      //Iterate through the event types (keys)
      cpKeys.forEach(function (eventTypeId) {
        //Iterate through the contact methods
        contactPreferences[eventTypeId] && contactPreferences[eventTypeId].forEach(function (contactMethod) {
          updatedContactPreferences.push({
            ContactEventType: eventTypeId,
            ContactMethod: contactMethod,
            OptIn: true
          });
        });
      });
      return updatedContactPreferences;
    }
  }, {
    key: "updateCustomerModel",
    value: function updateCustomerModel(customerModel, contactPreferences) {
      customerModel.ContactPreferences = this.getContactPreferences(contactPreferences);
    }
  }, {
    key: "initializeContactEventTypeToContactModel",
    value: function initializeContactEventTypeToContactModel() {
      var _this = this;
      //Iterate through all contact event types, and determine what contact methods should be associated to each one
      this.contactEventTypes.forEach(function (contactEventType) {
        //Get the mappings for the specific contact event type
        var contactEventTypeToContactMethodMappings = _this.contactMapping.filter(function (contactMapping) {
          var contactEventTypeCode = contactMapping.AdditionalProperties.find(function (additionalProperty) {
            return additionalProperty.Key === 'contact_event_type_code';
          });
          return contactEventTypeCode.Value === contactEventType.Value;
        });
        //If mappings are found, we should not set all contact methods as possible choices in the dropdown
        if (contactEventTypeToContactMethodMappings && contactEventTypeToContactMethodMappings.length) {
          var contactMethodOptions = [];
          //Interate through the found mappings for the contact event, and save the contact method label and value
          contactEventTypeToContactMethodMappings.forEach(function (contactEventTypeToContactMethodMapping) {
            var contactMethodFromMapping = contactEventTypeToContactMethodMapping.AdditionalProperties.find(function (additionalProperty) {
              return additionalProperty.Key === 'contact_method_code';
            });
            var contactMethod = _this.contactMethodOptions.find(function (contactMethodOption) {
              return contactMethodOption.value === contactMethodFromMapping.Value;
            });
            //Add the contact method lable and value to the contact method options array
            contactMethodOptions.push({
              label: contactMethod.label,
              value: contactMethod.value
            });
          });
          //Add the contact event name and value, and the associated contact methods
          _this.contactEventTypeToContactMethods.push({
            ContactEventTypeValue: contactEventType.Value,
            ContactEventTypeName: contactEventType.Name,
            ContactMethods: contactMethodOptions
          });
        } else {
          //If mappings are not found, set all possible contact methods as choices in the dropdown
          _this.contactEventTypeToContactMethods.push({
            ContactEventTypeValue: contactEventType.Value,
            ContactEventTypeName: contactEventType.Name,
            ContactMethods: _this.contactMethodOptions
          });
        }
      });
    }
  }]);
}();
export default {
  template: require('./contact.methods.section.html'),
  bindings: {
    contactEventTypes: '<',
    contactMapping: '<',
    contactMethodOptions: '<',
    customerModel: '<',
    contactPreferencesDictionary: '<',
    isFormSubmitted: '<',
    onFormChanged: '&'
  },
  controller: ContactMethodsSectionController
};